import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mb-10" }
const _hoisted_2 = /*#__PURE__*/_createVNode("h2", { class: "anchor fw-bolder mb-5" }, [
  /*#__PURE__*/_createVNode("a", { href: "#circular-progress-bar" }),
  /*#__PURE__*/_createTextVNode(" Circular progress bar ")
], -1)
const _hoisted_3 = { class: "rounded border p-10" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_progress = _resolveComponent("el-progress")
  const _component_CodeHighlighter = _resolveComponent("CodeHighlighter")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _createVNode(_component_el_progress, {
        type: "circle",
        percentage: 0
      }),
      _createVNode(_component_el_progress, {
        type: "circle",
        percentage: 25
      }),
      _createVNode(_component_el_progress, {
        type: "circle",
        percentage: 100,
        status: "success"
      }),
      _createVNode(_component_el_progress, {
        type: "circle",
        percentage: 70,
        status: "warning"
      }),
      _createVNode(_component_el_progress, {
        type: "circle",
        percentage: 50,
        status: "exception"
      }),
      _createVNode(_component_CodeHighlighter, { lang: "html" }, {
        default: _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.code4), 1)
        ]),
        _: 1
      })
    ])
  ]))
}